export enum NewsProfileComponentActions {
	LinkExternal = 'LINK_EXTERNAL',
	LinkInternal = 'LINK_INTERNAL',
	LinkAnchor = 'LINK_ANCHOR',
	LinkNews = 'LINK_NEWS',
	ModalGraph = 'MODAL_GRAPH',
	ModalInfographic = 'MODAL_INFOGRAPHIC',
}
